import { inputStyles } from '../input/input.style';

export const passwordStyles = inputStyles;
